import script from "./ProblemTab.vue?vue&type=script&setup=true&lang=js"
export * from "./ProblemTab.vue?vue&type=script&setup=true&lang=js"

import "./ProblemTab.vue?vue&type=style&index=0&id=c11f4c68&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c11f4c68"]])

export default __exports__